import React from 'react';
import PropTypes from 'prop-types';

import {ORDER_STATUS, ORDER_TRACKER_STEPS} from '../../constants/constant';
import ProgressBar from '../../components/ProgressBar/ProgressBar';
import {
  Wrapper,
  TrackerWrapper,
  TextWrapper,
  OrderConfirm,
  PreparingFood,
  ReadyForCollection,
  ReadyForDelivery,
  ProgressBarStyled,
  Info
} from './OrderTracker.style';
import {FormattedMessage} from 'react-intl';

const OrderTracker = props => {
  const {orderStatus, confirmTime, isOrderCancelled, cookingTime, futureOrder} = props;
  const currectStatus = ORDER_TRACKER_STEPS.indexOf(orderStatus.status);
  const isOrderActive = currectStatus >= ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.ORDERED) && !isOrderCancelled;
  const isOrderProcessing = currectStatus === ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.ORDERED);
  const isOrderCompleted = currectStatus > ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.ORDERED);
  const isConfirmActive = currectStatus >= ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.CONFIRMED) && !isOrderCancelled;
  const isCookingProcessing = currectStatus === ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.CONFIRMED);
  const isCookingCompleted = currectStatus > ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.CONFIRMED);

  const isFoodReady = ORDER_TRACKER_STEPS.indexOf(orderStatus.status) >= ORDER_TRACKER_STEPS.indexOf(ORDER_STATUS.READY) && !isOrderCancelled;
  const renderReadyIcon = props.isDelivery ?
    <ReadyForDelivery active={isFoodReady} /> : <ReadyForCollection active={isFoodReady} />;
  return (
    <Wrapper>
      <TrackerWrapper>
        <OrderConfirm active={isOrderActive} />
        <ProgressBarStyled>
          <ProgressBar
            duration={confirmTime}
            active={isOrderProcessing}
            completed={isOrderCompleted}
            cancelled={isOrderCancelled}
          />
        </ProgressBarStyled>
        <PreparingFood active={isConfirmActive} />
        <ProgressBarStyled>
          <ProgressBar
            duration={cookingTime}
            active={isCookingProcessing}
            completed={isCookingCompleted}
            cancelled={isOrderCancelled}
          />
        </ProgressBarStyled>
        {renderReadyIcon}
      </TrackerWrapper>
      <TextWrapper>
        <Info
          align="left"
          active={(isOrderProcessing || isOrderCompleted) && !isOrderCancelled}
        >
          <FormattedMessage id="confirmation.ordered.info" />
        </Info>
        <Info
          align="center"
          active={(isConfirmActive || isCookingCompleted) && !isOrderCancelled}
        >
          <FormattedMessage id={futureOrder ? 'confirmation.confirm.info' : 'confirmation.preparing.info'} />
        </Info>
        <Info
          align="right"
          active={isFoodReady && !isOrderCancelled}
        >
          <FormattedMessage id={props.isDelivery ? 'confirmation.readyForDelivery.info' : 'confirmation.readyForCollection.info'} />
        </Info>
      </TextWrapper>
    </Wrapper>
  );
};

OrderTracker.propTypes = {
  orderStatus: PropTypes.shape({
    status: PropTypes.string,
    timestamp: PropTypes.number,
    eta: PropTypes.string
  }).isRequired,
  isDelivery: PropTypes.bool.isRequired,
  isOrderCancelled: PropTypes.bool.isRequired,
  confirmTime: PropTypes.number.isRequired,
  cookingTime: PropTypes.number.isRequired,
  futureOrder: PropTypes.string
};

export default OrderTracker;



// WEBPACK FOOTER //
// ./containers/ConfirmationPage/OrderTracker.js